// Datos de empresas Chirak para multi-tenant
export const tenants = {
  chirakChile: {
    id: 'chirakChile',
    domain: 'tarifario.chirak.cl',
    mainDomain: 'chirak.cl',
    companyName: 'Chirak Turismo Chile',
    country: 'Chile',
    whatsappNumber: '+56912345678',
    logoUrl: '/logos/chirak-chile.png',
    email: 'contacto@chirak.cl',
    address: 'Santiago, Chile',
    theme: {
      primaryColor: '#1E40AF', // Azul Chile
      secondaryColor: '#DC2626' // Rojo Chile
    },
    currency: 'CLP',
    language: 'es-CL'
  },
  chirakPeru: {
    id: 'chirakPeru', 
    domain: 'tarifario.chirak.pe',
    mainDomain: 'chirak.pe',
    companyName: 'Chirak Turismo Perú',
    country: 'Perú',
    whatsappNumber: '+51987654321',
    logoUrl: '/logos/chirak-peru.png',
    email: 'contacto@chirak.pe',
    address: 'Lima, Perú',
    theme: {
      primaryColor: '#DC2626', // Rojo Perú
      secondaryColor: '#FFFFFF' // Blanco Perú
    },
    currency: 'PEN',
    language: 'es-PE'
  }
};

// Usuarios globales (pueden acceder a múltiples empresas)
export const globalUsers = [
  {
    id: 1,
    name: 'Administrador Chirak',
    email: 'admin@chirak.com',
    password: 'admin123',
    avatar: 'https://randomuser.me/api/portraits/men/1.jpg',
    country: 'Global',
    agency: 'Chirak Turismo',
    agencyType: 'internal' // internal o external
  },
  {
    id: 2,
    name: 'María González',
    email: 'maria.gonzalez@chirak.cl', 
    password: 'chile123',
    avatar: 'https://randomuser.me/api/portraits/women/2.jpg',
    country: 'Chile',
    agency: 'Chirak Turismo Chile',
    agencyType: 'internal'
  },
  {
    id: 3,
    name: 'Carlos Mendoza',
    email: 'carlos.mendoza@chirak.pe',
    password: 'peru123', 
    avatar: 'https://randomuser.me/api/portraits/men/3.jpg',
    country: 'Perú',
    agency: 'Chirak Turismo Perú',
    agencyType: 'internal'
  },
  {
    id: 4,
    name: 'Ana Morales',
    email: 'ana.morales@chirak.cl',
    password: 'agente123', 
    avatar: 'https://randomuser.me/api/portraits/women/4.jpg',
    country: 'Chile',
    agency: 'Chirak Turismo Chile',
    agencyType: 'internal'
  },
  {
    id: 5,
    name: 'Roberto Silva',
    email: 'roberto@viajeschile.cl',
    password: 'agente123',
    avatar: 'https://randomuser.me/api/portraits/men/5.jpg',
    country: 'Chile',
    agency: 'Viajes Chile Ltda.',
    agencyType: 'external'
  },
  {
    id: 6,
    name: 'Lucía Fernández',
    email: 'lucia@turismoandino.pe',
    password: 'agente123',
    avatar: 'https://randomuser.me/api/portraits/women/6.jpg',
    country: 'Perú',
    agency: 'Turismo Andino SAC',
    agencyType: 'external'
  },
  {
    id: 7,
    name: 'Diego Vargas',
    email: 'diego@explorasur.com.ar',
    password: 'agente123',
    avatar: 'https://randomuser.me/api/portraits/men/7.jpg',
    country: 'Argentina',
    agency: 'Explora Sur',
    agencyType: 'external'
  },
  {
    id: 8,
    name: 'Carmen Ruiz',
    email: 'carmen@amazontours.pe',
    password: 'agente123',
    avatar: 'https://randomuser.me/api/portraits/women/8.jpg',
    country: 'Perú',
    agency: 'Amazon Tours Perú',
    agencyType: 'external'
  }
];

// Roles y permisos por usuario y tenant
export const userTenantRoles = [
  // Administrador Chirak: admin en ambas empresas
  {
    userId: 1,
    tenantId: 'chirakChile',
    role: 'admin',
    status: 'active',
    cartaOperativaUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf'
  },
  {
    userId: 1,
    tenantId: 'chirakPeru',
    role: 'admin',
    status: 'active',
    cartaOperativaUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf'
  },
  // María: admin en Chile, agente en Perú
  {
    userId: 2,
    tenantId: 'chirakChile',
    role: 'admin',
    status: 'active',
    cartaOperativaUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf'
  },
  {
    userId: 2,
    tenantId: 'chirakPeru',
    role: 'agent',
    status: 'active',
    cartaOperativaUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf'
  },
  // Carlos: admin solo en Perú
  {
    userId: 3,
    tenantId: 'chirakPeru',
    role: 'admin',
    status: 'active',
    cartaOperativaUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf'
  },
  // Ana: agente solo en Chile
  {
    userId: 4,
    tenantId: 'chirakChile',
    role: 'agent',
    status: 'active',
    cartaOperativaUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf'
  },
  // Roberto (agente externo): acceso a ambas empresas
  {
    userId: 5,
    tenantId: 'chirakChile',
    role: 'agent',
    status: 'active',
    cartaOperativaUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/carta-viajes-chile.pdf'
  },
  {
    userId: 5,
    tenantId: 'chirakPeru',
    role: 'agent',
    status: 'active',
    cartaOperativaUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/carta-viajes-chile.pdf'
  },
  // Lucía (agente externo): especializada en Perú
  {
    userId: 6,
    tenantId: 'chirakPeru',
    role: 'agent',
    status: 'active',
    cartaOperativaUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/carta-turismo-andino.pdf'
  },
  // Diego (agente externo): acceso a Chile principalmente
  {
    userId: 7,
    tenantId: 'chirakChile',
    role: 'agent',
    status: 'active',
    cartaOperativaUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/carta-explora-sur.pdf'
  },
  // Carmen (agente externo): especializada en Perú
  {
    userId: 8,
    tenantId: 'chirakPeru',
    role: 'agent',
    status: 'active',
    cartaOperativaUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/carta-amazon-tours.pdf'
  }
];

// Categorías por tenant
export const categoriesByTenant = {
  chirakChile: [
    {
      id: 1,
      tenantId: 'chirakChile',
      name: 'Hoteles Premium Chile',
      description: 'Alojamiento de lujo en destinos exclusivos de Chile',
      image: 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6',
      active: true,
      products: [
        { id: 1, name: 'Hotel Atacama Luxury', price: 'CLP $180.000', description: 'Hotel 5 estrellas en San Pedro de Atacama' },
        { id: 2, name: 'Resort Patagonia Premium', price: 'CLP $250.000', description: 'Resort exclusivo en Torres del Paine' }
      ]
    },
    {
      id: 2,
      tenantId: 'chirakChile', 
      name: 'Tours Aventura Chile',
      description: 'Experiencias de aventura únicas en territorio chileno',
      image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4',
      active: true,
      products: [
        { id: 3, name: 'Trekking Patagonia', price: 'CLP $95.000', description: 'Caminata guiada en el Parque Nacional Torres del Paine' },
        { id: 4, name: 'Tour Desierto Atacama', price: 'CLP $120.000', description: 'Expedición completa por el desierto más árido del mundo' }
      ]
    },
    {
      id: 3,
      tenantId: 'chirakChile',
      name: 'Viñedos y Gastronomía',
      description: 'Tours enológicos y experiencias gastronómicas chilenas',
      image: 'https://images.unsplash.com/photo-1506377247377-2a5b3b417ebb',
      active: true,
      products: [
        { id: 5, name: 'Tour Valle de Casablanca', price: 'CLP $75.000', description: 'Degustación en viñedos boutique' },
        { id: 6, name: 'Ruta del Vino Maipo', price: 'CLP $85.000', description: 'Experiencia enológica premium' }
      ]
    }
  ],
  chirakPeru: [
    {
      id: 4,
      tenantId: 'chirakPeru',
      name: 'Machu Picchu Exclusivo',
      description: 'Experiencias premium en la ciudadela inca',
      image: 'https://images.unsplash.com/photo-1587595431973-160d0d94add1',
      active: true,
      products: [
        { id: 7, name: 'Camino Inca Clásico', price: 'PEN S/ 1,200', description: 'Trekking de 4 días al Machu Picchu' },
        { id: 8, name: 'Machu Picchu VIP', price: 'PEN S/ 800', description: 'Acceso exclusivo con guía especializado' }
      ]
    },
    {
      id: 5,
      tenantId: 'chirakPeru',
      name: 'Amazonía Peruana',
      description: 'Aventuras en la selva amazónica del Perú',
      image: 'https://images.unsplash.com/photo-1544735716-392fe2489ffa',
      active: true,
      products: [
        { id: 9, name: 'Lodge Amazónico 3D/2N', price: 'PEN S/ 650', description: 'Experiencia completa en lodge ecológico' },
        { id: 10, name: 'Expedición Iquitos', price: 'PEN S/ 950', description: 'Aventura de 5 días en corazón amazónico' }
      ]
    },
    {
      id: 6,
      tenantId: 'chirakPeru',
      name: 'Cultura Andina',
      description: 'Inmersión en la cultura ancestral peruana',
      image: 'https://images.unsplash.com/photo-1501594907352-04cda38ebc29',
      active: true,
      products: [
        { id: 11, name: 'Valle Sagrado Premium', price: 'PEN S/ 450', description: 'Tour completo por el Valle Sagrado' },
        { id: 12, name: 'Cusco Colonial', price: 'PEN S/ 320', description: 'City tour histórico y cultural' }
      ]
    }
  ]
};

// Función para detectar el tenant basado en el dominio actual
export const detectTenantFromDomain = () => {
  if (typeof window === 'undefined') {
    return 'chirakChile'; // Default para SSR
  }
  
  const currentDomain = window.location.hostname;
  
  // Buscar el tenant que coincida con el dominio
  const tenant = Object.values(tenants).find(t => 
    currentDomain.includes(t.domain) || 
    currentDomain.includes(t.mainDomain)
  );
  
  if (tenant) {
    return tenant.id;
  }
  
  // Para desarrollo local, determinar por subdominio o parámetro
  if (currentDomain.includes('localhost') || currentDomain.includes('127.0.0.1')) {
    const urlParams = new URLSearchParams(window.location.search);
    const tenantParam = urlParams.get('tenant');
    
    if (tenantParam === 'peru' || tenantParam === 'chirakPeru') {
      return 'chirakPeru';
    }
    if (tenantParam === 'chile' || tenantParam === 'chirakChile') {
      return 'chirakChile';
    }
    
    // Default para desarrollo
    return 'chirakChile';
  }
  
  // Fallback por defecto
  return 'chirakChile';
};

// Función para obtener la configuración del tenant actual
export const getCurrentTenantConfig = () => {
  const currentTenantId = detectTenantFromDomain();
  return tenants[currentTenantId] || tenants.chirakChile;
};

// Función para obtener el nombre de empresa según tenant ID
export const getTenantDisplayName = (tenantId) => {
  const displayNames = {
    chirakChile: 'Chirak Turismo Chile',
    chirakPeru: 'Chirak Turismo Perú',
    global: 'Todas las Empresas'
  };
  
  return displayNames[tenantId] || tenantId;
};